export default "__VITE_ASSET__BJz3P$Xt__"